<template>
    <div class="order-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" style="-webkit-user-drag: none;">
        <p-header title="從任務紀錄搜尋騎士"/>
        <div class="search">
            <img src="@/assets/img/search-green2.svg">
            <input type="text" v-model="keyword" @input="search" placeholder="輸入關鍵字搜尋 (店名、路名、品項名稱)">
        </div>
        <div class="list">
            <order-item v-for="order in orders" :key="order.id" :order="order"/>
        </div>
    </div>
</template>

<script>
    import Header from "../Header";
    import { getOrdersDriver } from '../../../apis';
    import OrderItem from "./OrderItem";

    export default {
        name: "OrderList",
        components: {
            'p-header': Header,
            'order-item': OrderItem,
        },
        data() {
            return {
                loading: false,
                keyword: '',
                keywordTime: null,
                orders: [],
                meta: {
                    current_page: 0,
                    total: 0,
                },
            }
        },
        computed: {
            canNotLoadMore() {
                return !(this.meta.total && this.meta.current_page < this.meta.last_page && !this.loading);
            },
        },
        methods: {
            search() {
                if (this.keywordTime) {
                    clearTimeout(this.keywordTime);
                }

                this.keywordTime = setTimeout( () => {
                    this.loadFirst();
                }, 800);
            },
            getPayload() {
                return {
                    page: this.meta.current_page + 1,
                    type: this.$route.params.type,
                    keywords: this.keyword,
                };
            },
            loadFirst() {
                this.meta = {
                    current_page: 0,
                    total: 0,
                };

                this.loading = true;
                getOrdersDriver(this.getPayload()).then(res => {
                    this.orders = res.data.data;
                    this.meta = res.data.meta;
                    this.loading = false;
                })
            },
            loadMore() {
                this.loading = true;
                getOrdersDriver(this.getPayload()).then(res => {
                    this.meta = res.data.meta;
                    this.orders = this.orders.concat(res.data.data);
                    this.loading = false;
                });
            },
        },
        created() {
            this.loadFirst();
        }
    }
</script>

<style lang="scss" scoped>
    .order-list {
        .search {
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 1px 5px 0 rgba(51,153,51,0.35);
            margin: 5px 15px 0 15px;
            display: flex;

            img {
                width: 20px;
                height: 20px;
                margin: 10px;
            }

            input {
                flex: 1;
                border: none;
            }
        }

        .list {
            padding: 15px;
        }
    }
</style>